module.exports = __webpack_public_path__ + "static/media/divide.00b6167b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/divide.jpg
// module id = 86
// module chunks = 0